// extracted by mini-css-extract-plugin
export default {"background":"AddProductPage_background__aLwep"};